import { IconButton } from '@latitude/icon-button';
import { Icon } from '@latitude/icons';
import type { JSX } from 'react';

import type { SpinnerButtonsProps } from './types';

export const SpinnerButtons = ({
  onIncrement,
  onDecrement,
  label,
}: SpinnerButtonsProps): JSX.Element => (
  <div className="flex size-7 flex-col items-center justify-between gap-0">
    <IconButton
      size="tiny"
      htmlType="button"
      type="ghost"
      variant="neutral"
      onClick={onIncrement}
      aria-label={`Increase ${label}`}
      className="mr-[-12px] h-3/6 rounded-b-none rounded-tl-none rounded-tr-[2px]"
      icon={<Icon name="chevron-left" direction="up" />}
    />
    <IconButton
      size="tiny"
      htmlType="button"
      type="ghost"
      variant="neutral"
      onClick={onDecrement}
      aria-label={`Decrease ${label}`}
      className="mr-[-12px] h-3/6 rounded-t-none rounded-bl-none rounded-br-[2px]"
      icon={<Icon name="chevron-left" direction="down" />}
    />
  </div>
);
